const baseUrl = process.env.REACT_APP_API_ENDPOINT || "/";

const httpClient = async (
  endpoint,
  { method = "GET", headers = {}, body } = {}
) => {
  const config = {
    method,
    headers: {
      "Content-Type": "application/json",
      "Authorization": "guest",
      ...headers,
    },
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(`${baseUrl}${endpoint}`, config);

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Errore nella richiesta");
    }

    return await response.json();
  } catch (error) {
    console.error("Errore HTTP:", error);
    throw error;
  }
};

export default httpClient;
